import { useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useTranslation } from "react-i18next";
import HelpDrawer from "../HelpDrawer";

/**
 * A self-contained "?" help button for race prediction. Opens the same right-hand
 * manual as the topbar help, jumped straight to the "Predict a race" flow, so
 * there is only ever one copy of the prediction text to keep up to date.
 * Drop it wherever a prediction can be started.
 */
const RacePredictionHelp = ({ fontSize = 16, color, sx }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);

  return (
    <>
      <Tooltip title={t("racePredictionHelp", "How race prediction works")}>
        <IconButton size="small" onClick={handleOpen} sx={{ p: 0.25, color, ...sx }}>
          <HelpOutlineIcon sx={{ fontSize }} />
        </IconButton>
      </Tooltip>
      <HelpDrawer open={open} onClose={() => setOpen(false)} chapter="predict" />
    </>
  );
};

export default RacePredictionHelp;
